import * as React from 'react';

import CustomApp56 from './CustomApp56';

export const customApp56 = () => <CustomApp56 />;

export default {
    title: 'Illustration/CustomApp56',
    component: CustomApp56,
    parameters: {
        notes: "`import CustomApp56 from 'box-ui-elements/es/illustration/CustomApp56';`",
    },
};
